// extracted by mini-css-extract-plugin
export var avatarContainer = "_bh-0";
export var avatarTypingWave = "_bh-i";
export var gray = "_bh-f";
export var green = "_bh-c";
export var icon = "_bh-9";
export var image = "_bh-1";
export var lg = "_bh-6";
export var md = "_bh-5";
export var presenceDot = "_bh-b";
export var red = "_bh-d";
export var sm = "_bh-4";
export var status = "_bh-a";
export var typingDot = "_bh-h";
export var typingPill = "_bh-g";
export var xl = "_bh-7";
export var xs = "_bh-3";
export var xxl = "_bh-8";
export var xxs = "_bh-2";
export var yellow = "_bh-e";